var hproWebPushConfig = null;
var subscriptionService = null;

var messageRespondSuccess = function (event, data) {
    event.ports[0].postMessage({
        status: 'success',
        data: data
    });
};
var messageRespondError = function (event, data) {
    event.ports[0].postMessage({
        status: 'error',
        error: data,
    });
};

var identifier = null;
var cdsUserData = null;
var methods = {
    init: function (event, content) {
        hproWebPushConfig = content;
        messageRespondSuccess(event, 'Initialized');
    },
    setUserData: function (event, UserData) {
        cdsUserData = UserData;
        identifier = UserData.cds_contact_id;
        messageRespondSuccess(event, 'User Data updated');
    },
    getUserData: function (event, cdsUserData) {
        if (!cdsUserData) {
            messageRespondError(event, 'No user data setup');
        }

        messageRespondSuccess(event, cdsUserData);
    },
    setIdentifier: function (event, newIdentifier) {
        identifier = newIdentifier;
        messageRespondSuccess(event, 'Identifier updated');
    },
    getIdentifier: function (event) {
        if (!identifier) {
            messageRespondError(event, 'No identifier setup');
        }

        messageRespondSuccess(event, identifier);
    }
};

var messageListener = function (event) {
    if (!hproWebPushConfig && event.data.command != 'init') {
        messageRespondError(event, 'Not initialized');
        return;
    }
    
    if (event.data.command && methods[event.data.command]) {
        var waitUntil = methods[event.data.command](event, event.data.data);
        if (waitUntil) {
            event.waitUntil(waitUntil);
        }
    }
    else {
        messageRespondError(event, 'Invalid Method');
    }
};

function send_message_to_client(client, msg) {
    return new Promise(function (resolve, reject) {
        var msg_chan = new MessageChannel();

        msg_chan.port1.onmessage = function (event) {
            if (event.data.error) {
                reject(event.data.error);
            } else {
                resolve(event.data);
            }
        };

        client.postMessage("SW Says: '" + msg + "'", [msg_chan.port2]);
    });
}

function send_message_to_all_clients(msg) {
    clients.matchAll().then(function (clients) {
        clients.forEach(function (client) {
            send_message_to_client(client, msg).then(function (m) { 
                console.log("SW Received Message: " + m); 
            });
        })
    })
}

self.addEventListener('notificationclick', function(event){
    var url = event.notification.data.targetUrl;
    if(!url){
        return;
    }

    event.notification.close();
    event.waitUntil(
        clients.matchAll({type:'window'}).then(function(windowClients){
            // check if there is already a window/tab open with the target URL
            for(var i = 0; i < windowClients.length; i++){
                var client = windowClients[i];
                if(client.url === url && 'focus' in client){
                    return client.focus();
                }
            }
            // if not open the target URL in a new window/tab
            if(clients.openWindow){
                return clients.openWindow(url);
            }
        })
    );
});

self.addEventListener('message', messageListener);
self.addEventListener('statechange', function () {});
self.addEventListener('pushsubscriptionchange', function (event) {
    if (subscriptionService) {
        event.waitUntil(subscriptionService.update());
    }
});

self.addEventListener('install', function (event) { return event.waitUntil(self.skipWaiting()); } );
self.addEventListener('activate', function (event) { return event.waitUntil(self.clients.claim()); } );

self.addEventListener('push', function (event) {
    if (!(self.Notification && self.Notification.permission === 'granted')) {
        return;
    }

    function sendNotification (title, options) {
        // you could refresh a notification badge here with postMessage API
        var notification = self.registration.showNotification(title, options);
        return notification;
    };

    if (event.data) {
        var jsonData = null;
        try {
            var jsonData = event.data.json();
            //Set targetUrl to data object of Notification object
            if(jsonData['options'] && jsonData['options']['targetUrl']){
                jsonData['options']['data'] = {
                    'targetUrl': jsonData['options']['targetUrl']
                };
            }
        }
        catch (e) {
            jsonData = {
                title: 'Web Push Sample',
                options: {
                  body: event.data
                },
            };
        }

        if (jsonData.test) {
            return true;
        }

        event.waitUntil(sendNotification(jsonData.title, jsonData.options));
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/worker.js
// module id = 38
// module chunks = 1